import { type RpmPickListPredictionAccuraciesRelatedPagedData } from '@on3/api';
import { Link } from '@on3/ui-lib/components/Link';
import { createUrl } from '@on3/ui-lib/utils/url';
import { PlayerPrediction } from '@public/components/Player/PredictionsModule/PlayerPrediction';

import styles from './PlayerPredictionsModule.module.scss';

interface IPredictionsModule {
  predictions: RpmPickListPredictionAccuraciesRelatedPagedData;
  title?: string;
}

export const PredictionsModule = ({
  predictions,
  title = 'Latest Predictions',
}: IPredictionsModule) => {
  const predictionsList = predictions?.list ?? [];
  // TODO: submit api ticket to add year to the api response for relatedModel
  const predictionsModel = predictions.relatedModel ?? {};

  return (
    <div className={styles.block}>
      <h3>{title}</h3>
      <ul className={styles.predictionsList}>
        {predictionsList.map((prediction) => (
          <li key={prediction.player?.key}>
            <PlayerPrediction {...prediction} />
          </li>
        ))}
      </ul>
      <footer className={styles.footer}>
        <Link
          className={styles.viewAll}
          href={createUrl(['rivals', 'expert-predictions', 'football', 'all'])}
        >
          View All
        </Link>
      </footer>
    </div>
  );
};
